

import { Modals, Routes } from './generate';
import { components, hooks, utils } from './client';

export type Path =
  | `/`
  | `/app`
  | `/campaigns`
  | `/common/entityLayout`
  | `/common/wizardLayout`
  | `/contextSystem`
  | `/deviatedLineItems`
  | `/faq`
  | `/insights`
  | `/ioSettings/create`
  | `/ioSettings/edit/:id`
  | `/liSettings/edit/:id`
  | `/reporting/doohReport/:lineItemId`
  | `/reporting/driveToStore`
  | `/reporting/driveToStore/:entityType/:entityId`
  | `/sharedReport/:sharedReportId/report`

export type Params = {
  '/ioSettings/edit/:id': { id: string }
  '/liSettings/edit/:id': { id: string }
  '/reporting/doohReport/:lineItemId': { lineItemId: string }
  '/reporting/driveToStore/:entityType/:entityId': { entityType: string; entityId: string }
  '/sharedReport/:sharedReportId/report': { sharedReportId: string }
}

export type ModalPath = `/app/modal` | `/campaigns/AdsValidation` | `/campaigns/new/advertiserModal` | `/campaigns/new/campaignPlanModal` | `/campaigns/new/campaignPlanSettingsModal` | `/campaigns/new/cartographyModal` | `/campaigns/new/insertionOrderModal` | `/campaigns/new/lineItemModal` | `/campaigns/new/lineItemSettingsModal` | `/campaigns/new/poiFinderScreensModal` | `/campaigns/new/poiFinderVenuesModal` | `/campaigns/new/uploadLocationsModal`

export { Modals, Routes };
export const { Link, Navigate } = components<Path, Params>();
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>();
export const { redirect } = utils<Path, Params>();
